import { createContext } from 'react';
import { AccountService } from '../../contexts/identityaccess/application/services/AccountService';
import { ApiClientService } from '../../contexts/identityaccess/application/services/ApiClientService';
import { DeadLetterService } from '../../contexts/messaging/application/services/DeadLetterService';

/**
 * Services available in the context
 */
export interface Services {
  accountService: AccountService;
  apiClientService: ApiClientService;
  deadLetterService: DeadLetterService;
}

/**
 * Services Context
 */
export const ServicesContext = createContext<Services | undefined>(undefined);
